/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DuplicateWorkspaceResponse } from '../../models/duplicate-workspace-response';

export interface DuplicateWorkspace$Params {

/**
 * Workspace ID
 */
  workspaceId: number;

/**
 * New workspace ID
 */
  newWorkspaceId: number;
}

export function duplicateWorkspace(http: HttpClient, rootUrl: string, params: DuplicateWorkspace$Params, context?: HttpContext): Observable<StrictHttpResponse<DuplicateWorkspaceResponse>> {
  const rb = new RequestBuilder(rootUrl, duplicateWorkspace.PATH, 'post');
  if (params) {
    rb.path('workspaceId', params.workspaceId, {});
    rb.path('newWorkspaceId', params.newWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DuplicateWorkspaceResponse>;
    })
  );
}

duplicateWorkspace.PATH = '/workspaces/{workspaceId}/duplicate/{newWorkspaceId}';
